// BroadbandCard.tsx
import React from 'react';
import useGlobalStore from "../stores/globalStore";

function BroadbandCard({ data }) {
  //Stores
  const selectedBroadband = useGlobalStore((state) => state.selectedBroadband);
  const setSelectedBroadband = useGlobalStore((state) => state.setSelectedBroadband);

  //Functions
  const handleCardSelection = () => {
    setSelectedBroadband(data);
  };

  return (
    <div
      key={data.id}
      className={
        selectedBroadband.id === data.id
          ? `tel-pt-card selected tel-pt-${data.type}-card `
          : ` tel-pt-card tel-pt-${data.type}-card `
      }
      onClick={handleCardSelection}
    >
      <div className="tel-pt-card__content">
        {data.image && <div className="tel-pt-card__image" style={{ backgroundImage: `url(${data.image})` }}></div>}

        <div className="tel-pt-card__info">
          <h3 className="tel-pt-card__title">{data.title.replace(/&#038;/g, "&")}</h3>
          {data.description && (
            <p className="tel-pt-card__description" dangerouslySetInnerHTML={{ __html: data.description }} />
          )}
        </div>
        {(data.price || data.monthly_price) && (
          <div className="tel-pt-card__price-container">
            {!data.discount_price && (
              <p className="tel-pt-card__price">
                {data.price || data.monthly_price} kr/mån
              </p>
            )}
            {data.discount_price && (
              <>
                <p className="tel-pt-card__discount-price">
                  {data.discount_price} kr/mån
                </p>
                <p className="tel-pt-card__price tel-pt-card__price-has-discount">
                  {data.price || data.monthly_price} kr/mån
                </p>
                <p className="tel-pt-card__discount-terms">*{data.discount_terms}</p>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default BroadbandCard;